import { useState } from "react";
import { logger } from "@/lib/logger";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

const EMPTY = { name: "", line_code: "", machine_type: "General", max_hourly_capacity: 100, status: "active" };
const STATUSES = [["active", "Active"], ["idle", "Idle"], ["downtime", "Downtime"]];

export function MachineFormDialog({ open, onOpenChange, onCreate }) {
  const [form, setForm] = useState(EMPTY);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    try {
      await onCreate({ ...form, max_hourly_capacity: Number(form.max_hourly_capacity) });
      onOpenChange(false);
      setForm(EMPTY);
    } catch (err) {
      logger.error("Add line failed (toast shown by handler):", err);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="machine-form-modal">
        <DialogHeader><DialogTitle className="font-display">Add Production Line</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5">
              <Label>Line Code</Label>
              <Input value={form.line_code} onChange={(e) => set("line_code", e.target.value)} placeholder="LINE-05" required data-testid="machine-form-code" />
            </div>
            <div className="space-y-1.5">
              <Label>Machine Name</Label>
              <Input value={form.name} onChange={(e) => set("name", e.target.value)} placeholder="Laser Cutter" required data-testid="machine-form-name" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5">
              <Label>Type</Label>
              <Input value={form.machine_type} onChange={(e) => set("machine_type", e.target.value)} />
            </div>
            <div className="space-y-1.5">
              <Label>Max Hourly Capacity</Label>
              <Input type="number" min="1" value={form.max_hourly_capacity} onChange={(e) => set("max_hourly_capacity", e.target.value)} required data-testid="machine-form-capacity" />
            </div>
          </div>
          <div className="space-y-1.5">
            <Label>Status</Label>
            <Select value={form.status} onValueChange={(v) => set("status", v)}>
              <SelectTrigger><SelectValue /></SelectTrigger>
              <SelectContent>
                {STATUSES.map(([v, label]) => <SelectItem key={v} value={v}>{label}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
            <Button type="submit" className="bg-blue-600 hover:bg-blue-700" data-testid="machine-form-submit">Add Line</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
